import { useTheme, useMediaQuery } from '@mui/material';
import { Icon as MdiIcon } from '@mdi/react';

import { TColorKeys } from 'theme/palette';

export interface IProps extends React.ComponentProps<typeof MdiIcon> {
    color?: TColorKeys;
    size?: string;
    sizeSm?: string;
}

export const Icon = ({ color, size, sizeSm, ...other }: IProps) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const colorValue = color ? theme.palette[color].main : undefined;

    let iconSize = size;

    if (sizeSm && isSm) iconSize = sizeSm;

    return <MdiIcon color={colorValue} size={iconSize} {...other} />;
};
